import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// appsolut base components
import StyledBox from '../../components/controls/StyledBox';
import StyledTypography from '../../components/controls/StyledTypography';

function FormMessage({ message, open, severity, ...rest }) {
  return (
    <Fragment>
      {open && (
        <StyledBox mb={2}>
          <StyledTypography display="block" variant="button" color={severity} {...rest}>
            {message}
          </StyledTypography>
        </StyledBox>
      )}
    </Fragment>
  );
}

FormMessage.defaultProps = {
  open: false,
  severity: 'error',
};

FormMessage.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool,
  severity: PropTypes.string,
};

export default FormMessage;
